import { useState, useMemo } from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import OptionValueIngredients from "./OptionValueIngredients";

interface PersistedOptionValue {
  id: string;
  title: string;
}

interface OptionValueIngredientsSectionProps {
  restaurantId: string;
  values: PersistedOptionValue[];
}

const OptionValueIngredientsSection = ({
  restaurantId,
  values,
}: OptionValueIngredientsSectionProps) => {
  const persisted = useMemo(
    () => values.filter((v) => !!v.id && !!v.title),
    [values]
  );
  const [selected, setSelected] = useState<string>("");

  if (persisted.length === 0) {
    return (
      <p className="text-sm text-muted-foreground">
        Enregistrez d'abord les valeurs de cette option pour pouvoir leur lier
        des ingrédients.
      </p>
    );
  }

  return (
    <div className="space-y-4">
      <div>
        <label className="block text-xs font-medium text-muted-foreground mb-1">
          Choisir une valeur
        </label>
        <Select value={selected} onValueChange={setSelected}>
          <SelectTrigger>
            <SelectValue placeholder="Sélectionner une valeur..." />
          </SelectTrigger>
          <SelectContent>
            {persisted.map((v) => (
              <SelectItem key={v.id} value={v.id}>
                {v.title}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      {selected && (
        <OptionValueIngredients
          optionValueId={selected}
          restaurantId={restaurantId}
        />
      )}
    </div>
  );
};

export default OptionValueIngredientsSection;
